import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './router'
import store from './store'
import VueQrcode from '@chenfengyuan/vue-qrcode';

Vue.config.productionTip = false

Vue.component(VueQrcode.name, VueQrcode);

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
